import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { CustomButton } from '../../../components/CustomButton';
import { Card } from 'primereact/card';
import { ReactComponent as SendButton } from '../../../assets/svgIcons/svgIcons/sendbuttonicon.svg';
import { ReactComponent as CancelButton } from '../../../assets/svgIcons/cancelIcon.svg';
import { useForm, Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { useLayout } from '../../../context/LayoutContext';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';
import CONSTANTS from '../../../config/Constants';
import { validateMediaSize } from '../../../utils/templateUtils';
import { Text } from '../../../components/Text';
import { API_GET_IMG_URL, API_UPLOAD_IMG } from '../../../api/chat.service';
import { sendMessage, startChat } from '../../../reducers/wca/sales-support/sales-support-action';
import { useUtility } from '../../../context/UtilityContext';
import { ProgressBar } from 'primereact/progressbar';
const StartConversation = () => {
  const { templateList } = useSelector((state) => state.wcaMessageTemplate);
  const { user } = useSelector((state) => state.wcaEnqChats);
  const { loading } = useSelector((state) => state.shareMessage);

  const [isStartConversation, setIsStartConversation] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isTemplateSelected, setIsTemplateSelected] = useState(false);
  const [file, setFile] = useState(null);
  const [tempVariables, setTempvariables] = useState([]);
  const [message, setMessage] = useState('');
  const [headerFormat, setHeaderFormat] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const defaultValues = {};
  const mediaFileRef = useRef();
  const dispatch = useDispatch();
  const { setLoading, toast } = useLayout();
  const { selectedMetadataId } = useUtility();

  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({ defaultValues });

  useEffect(() => {
    setIsTemplateSelected(false);
    setIsStartConversation(false);
    setSelectedTemplate(null);
  }, [user]);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  const handleTemplateChange = (temp) => {
    setSelectedTemplate(temp.target.value);
    setIsTemplateSelected(true);
  };

  const handleEditVariable = (e, id) => {
    const updated = tempVariables.map((item) =>
      item.id === id ? { ...item, variableValue: e.target.value } : item,
    );
    setTempvariables(updated);
  };

  // useEffect(() => {
  //   if (!selectedTemplate?.components) return;

  //   const body = selectedTemplate.components.find((c) => c.type === 'BODY');
  //   const header = selectedTemplate.components.find((c) => c.type === 'HEADER');

  //   const bodyText = body?.text || '';

  //   setValue('message', bodyText);
  //   setMessage(bodyText);
  //   setHeaderFormat(header?.format);

  //   // ✅ Extract variables from {{ }}
  //   const matches = bodyText.match(/{{(.*?)}}/g) || [];

  //   const vars = matches.map((match) => {
  //     const key = match.replace(/[{}]/g, '');

  //     return {
  //       id: Math.random(),
  //       variableKey: key,
  //       variableName: match,
  //       variableValue: '',
  //     };
  //   });

  //   setTempvariables(vars);
  // }, [selectedTemplate]);

  useEffect(() => {
    if (!selectedTemplate?.components) return;

    const body = selectedTemplate.components.find(
      (c) => c.type === 'BODY'
    );

    const header = selectedTemplate.components.find(
      (c) => c.type === 'HEADER'
    );

    setValue('message', body?.text || '');
    setMessage(body?.text || '');

    setHeaderFormat(header?.format);

    let allVariables = [];

    const extractVariables = (text, section) => {
      if (!text) return [];

      const matches = text.match(/{{(.*?)}}/g) || [];

      return matches.map((match) => ({
        id: Math.random(),
        section,
        variableKey: match.replace(/[{}]/g, ''),
        variableName: match,
        variableValue: '',
      }));
    };

    allVariables = [
      ...extractVariables(header?.text, 'HEADER'),
      ...extractVariables(body?.text, 'BODY'),
    ];

    setTempvariables(allVariables);
  }, [selectedTemplate]);

  const uploadMediaToS3 = async (file) => {
    try {
      setUploading(true); // ✅ START
      setUploadProgress(0); // reset

      const respUrl = await API_GET_IMG_URL();

      const uploadUrl = respUrl.data.src;
      const fileUrl = respUrl.data.url;

      await API_UPLOAD_IMG(uploadUrl, file, file.type, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        },
      });

      setUploading(false); // ✅ END

      return fileUrl;
    } catch (err) {
      setUploading(false); // ✅ IMPORTANT (on error also)
      throw err;
    }
  };

  // const buildTemplatePayload = async () => {
  //   const bodyComponent = selectedTemplate.components.find((c) => c.type === 'BODY');
  //   const headerComponent = selectedTemplate.components.find((c) => c.type === 'HEADER');

  //   let components = [];

  //   // ✅ 1. HEADER (ONLY for media)
  //   if (headerComponent && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerComponent.format)) {
  //     if (!file) {
  //       toast.current.show({
  //         severity: 'error',
  //         detail: 'Please upload file',
  //       });
  //       return null;
  //     }

  //     const fileUrl = await uploadMediaToS3(file);

  //     const type = headerComponent.format.toLowerCase();

  //     let mediaPayload = {
  //       type,
  //       [type]: {
  //         link: fileUrl,
  //       },
  //     };

  //     // ✅ Only for document → add filename
  //     if (type === 'document') {
  //       mediaPayload.document.filename = file?.name || 'file';
  //     }

  //     components.push({
  //       type: 'header',
  //       parameters: [mediaPayload],
  //     });
  //   }

  //   // ✅ 2. BODY (ALWAYS REQUIRED)
  //   if (bodyComponent) {
  //     let bodyParams = [];

  //     if (tempVariables.length > 0) {
  //       bodyParams = tempVariables.map((item) => {
  //         if (!item.variableValue || !item.variableValue.trim()) {
  //           toast.current.show({
  //             severity: 'error',
  //             detail: `Please fill ${item.variableKey}`,
  //           });
  //           return null;
  //         }

  //         return {
  //           type: 'text',
  //           text: item.variableValue,
  //         };
  //       });
  //     }

  //     components.push({
  //       type: 'body',
  //       parameters: bodyParams,
  //     });
  //   }

  //   return {
  //     messaging_product: 'whatsapp',
  //     to: user?.phone,
  //     type: 'template',
  //     template: {
  //       name: selectedTemplate.name,
  //       language: {
  //         code: selectedTemplate.language || 'en',
  //       },
  //       components,
  //     },
  //   };
  // };

  const buildTemplatePayload = async () => {
    let variables = {};

    // =========================
    // BODY VARIABLES
    // =========================

    const bodyVariables = tempVariables.filter(
      (item) => item.section === 'BODY'
    );

    if (bodyVariables.length > 0) {
      variables.BODY = {};

      bodyVariables.forEach((item) => {
        if (!item.variableValue?.trim()) {
          throw new Error(
            `Please fill ${item.variableKey}`
          );
        }

        // remove {{ }}
        const key = item.variableKey;

        variables.BODY[key] = item.variableValue;
      });
    }

    // =========================
    // HEADER MEDIA
    // =========================

    if (
      ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerFormat)
    ) {
      if (!file) {
        throw new Error('Please upload file');
      }

      const fileUrl = await uploadMediaToS3(file);

      variables.HEADER = {};

      // IMAGE
      if (headerFormat === 'IMAGE') {
        variables.HEADER.IMAGE = {
          link: fileUrl,
        };
      }

      // VIDEO
      if (headerFormat === 'VIDEO') {
        variables.HEADER.VIDEO = {
          link: fileUrl,
        };
      }

      // DOCUMENT
      if (headerFormat === 'DOCUMENT') {
        variables.HEADER.DOCUMENT = {
          link: fileUrl,
          filename: file?.name || 'file',
        };
      }
    }

    // =========================
    // HEADER TEXT VARIABLES
    // =========================

    const headerVariables = tempVariables.filter(
      (item) => item.section === 'HEADER'
    );

    // only when NOT media header
    if (
      headerVariables.length > 0 &&
      !['IMAGE', 'VIDEO', 'DOCUMENT'].includes(
        headerFormat
      )
    ) {
      variables.HEADER = {};

      headerVariables.forEach((item) => {
        if (!item.variableValue?.trim()) {
          throw new Error(
            `Please fill ${item.variableKey}`
          );
        }

        const key = item.variableKey;

        variables.HEADER[key] =
          item.variableValue;
      });
    }

    return {
      templateId:
        selectedTemplate?.templateId ||
        selectedTemplate?.id,

      variables,
    };
  };
  const sendTemplateMessage = async () => {
    try {
      const payload = await buildTemplatePayload();
      if (!payload) return;
      dispatch(
        startChat({
          metadataid: selectedMetadataId,
          phone: user?.phone,
          data: payload,
        }),
      );

      // reset UI
      setFile(null);
      setTempvariables([]);
      setSelectedTemplate(null);
      setIsTemplateSelected(false);
    } catch (error) {
      toast.current.show({
        severity: 'error',
        detail: error.message || 'Something went wrong',
      });
    }
  };

  const handleDeleteMedia = () => {
    setFile(null);
  };
  const previewFile = (e) => {
    // Reading New File (open file Picker Box)
    const reader = new FileReader();
    // Gettting Selected File (user can select multiple but we are choosing only one)
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      reader.readAsDataURL(selectedFile);
    }
    // As the File loaded then set the stage as per the file type
    // reader.onload = (readerEvent) => {
    //   if (selectedFile.type.includes("image")) {
    //     setImagePreview(readerEvent.target.result);
    //   } else if (selectedFile.type.includes("video")) {
    //     setVideoPreview(readerEvent.target.result);
    //   } else if (selectedFile.type.includes("pdf")) {
    //     setDocumentPreview(readerEvent.target.result);
    //   }
    // };
  };

  const mediaSelect = (icon, accept) => {
    const headerComponent = selectedTemplate?.components?.find((c) => c.type === 'HEADER');
    if (file) {
      var { isValid, acceptedSize } = validateMediaSize(
        file?.size,
        headerComponent?.format?.toLowerCase(),
      );
    }

    return (
      <div className="w-12 lg:w-10">
        {' '}
        {!file ? (
          <div className="field">
            <input
              ref={mediaFileRef}
              type="file"
              accept={`${accept}`}
              hidden
              onChange={previewFile}
            />
            <button
              type="button"
              className="w-full temp-img flex gap-3 p-3 my-2 cursor-pointer"
              onClick={() => mediaFileRef.current.click()}
            >
              <i className={`pi ${icon}`} />
              <Text type={'sub-heading'}>Choose {headerFormat?.toLowerCase()}</Text>
            </button>
          </div>
        ) : (
          <>
            <div className="temp-img-upload">
              <div className="flex gap-2 justify-content-between align-items-center">
                <div className="flex gap-2 align-items-center">
                  <i className={`pi ${icon}`} />
                  <Text type={'sub-heading'}>{file.name}</Text>
                </div>
                <i
                  className="pi pi-trash cursor-pointer"
                  style={{ float: 'right' }}
                  onClick={handleDeleteMedia}
                />
              </div>
            </div>
            {uploading && (
              <div className="mt-2">
                <ProgressBar value={uploadProgress} />
                <small>{uploadProgress}% uploading...</small>
              </div>
            )}
            {!isValid && (
              <div className="mb-2">
                <small className="p-error ">
                  {headerComponent?.format?.toLowerCase()} size should be less than {acceptedSize}{' '}
                  MB.
                </small>
              </div>
            )}
          </>
        )}{' '}
      </div>
    );
  };

  const mediaTemplate = () => {
    switch (headerFormat) {
      case 'IMAGE':
        return mediaSelect('pi-image', 'image/jpeg, image/png');
      case 'VIDEO':
        return mediaSelect('pi-video', 'video/mp4');
      case 'DOCUMENT':
        return mediaSelect('pi-file', '.doc,.docx,.pdf');
      default:
        return null;
    }
  };

  function templateMsg() {
    return (
      <form
        onSubmit={handleSubmit(async (data) => {
          // ✅ 1. Validate variables
          if (tempVariables.length > 0) {
            const emptyVar = tempVariables.find((v) => !v.variableValue || !v.variableValue.trim());

            if (emptyVar) {
              toast.current.show({
                severity: 'error',
                detail: `Please fill ${emptyVar.variableKey}`,
              });
              return;
            }
          }

          // ✅ 2. Validate media
          if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerFormat) && !file) {
            toast.current.show({
              severity: 'error',
              detail: 'Please upload file',
            });
            return;
          }

          // ✅ 3. DIRECT API CALL
          await sendTemplateMessage();
        })}
        className="p-fluid w-full"
        encType="multipart/form-data"
      >
        <div className="field mt-2 w-12 lg:w-10">
          <label htmlFor="message">Body *</label>
          <Controller
            name="message"
            control={control}
            rules={{ required: 'message is required.' }}
            render={({ field, fieldState }) => (
              <InputTextarea
                className={classNames({
                  'p-invalid': fieldState.invalid,
                })}
                id={field.name}
                value={message}
                rows={5}
                cols={30}
                maxLength={1028}
                autoResize
                disabled
                placeholder="Enter your message (max 1028 chars)"
              />
            )}
          />

          <div className="my-2">
            {tempVariables?.map((item, i) => {
              return (
                <div className="flex gap-2 justify-content-center align-items-center my-3" key={i}>
                  <div className="w-3">
                    {i == 0 && <label>Variable</label>}
                    <InputText value={item.variableName} disabled />
                  </div>
                  <div className="relative flex-grow-1">
                    {i == 0 && <label>Value</label>}
                    <div className="flex align-items-center gap-2">
                      <Controller
                        rules={{ required: true }}
                        id={item.variableName}
                        name={item.variableName}
                        control={control}
                        render={({ field, fieldState }) => (
                          <InputText
                            id={field.name}
                            name={field.name}
                            placeholder={`Enter value`}
                            className={classNames('w-full', {
                              'p-invalid': fieldState.invalid,
                            })}
                            value={item.variableValue}
                            onChange={(e) => {
                              handleEditVariable(e, item.id);
                              field.onChange(e.target.value); // 🔥 IMPORTANT
                            }}
                            required
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {headerFormat !== 'TEXT' && mediaTemplate(selectedTemplate)}
        <div className={`sendbutton w-full flex justify-content-between mt-4 `}>
          <div className="w-6 md:w-4">
            <Dropdown
              value={selectedTemplate}
              options={templateList}
              onChange={handleTemplateChange}
              optionLabel="elementName"
              placeholder="Choose Template"
              className="w-full capitalize"
              filter
            />
          </div>
          <button type="submit">
            <SendButton />
          </button>
        </div>
      </form>
    );
  }

  return (
    <div className="w-12 flex flex-column">
      {!isTemplateSelected && (
        <div className="pt-2 pb-2">
          <div className="text-base font-semibold">{CONSTANTS.ENQ_CHAT_BROADCAST_MSG_HEADER}</div>
          <div>{CONSTANTS.ENQ_CHAT_BROADCAST_MSG}</div>
        </div>
      )}

      {!isTemplateSelected ? (
        <div className="w-full md:w-5 lg:w-4 xl:w-3">
          {!isStartConversation ? (
            <CustomButton
              varient="filled"
              label={'Start Conversation'}
              onClick={() => {
                setIsStartConversation(!isStartConversation);
              }}
            />
          ) : (
            <Dropdown
              value={selectedTemplate}
              options={templateList}
              onChange={handleTemplateChange}
              optionLabel="name"
              placeholder="Choose Template"
              className="w-full"
              filter
            />
          )}
        </div>
      ) : (
        <div className="w-full">
          <div className="card __cardDiv">
            <Card className={`  `}>
              <div className="w-full flex justify-content-end pr-1">
                <div
                  className="p-1 border-circle flex justify-content-center align-items-center cursor-pointer"
                  style={{ height: '30px', width: '30px' }}
                  onClick={() => {
                    setIsTemplateSelected(!isTemplateSelected);
                    setSelectedTemplate(null);
                    setIsStartConversation(false);
                    setFile(null);
                  }}
                >
                  <CancelButton />
                </div>
              </div>
              <div className="flex flex-column justify-content-center align-items-center w-full">
                {templateMsg()}
              </div>
            </Card>
          </div>
        </div>
      )}
    </div>
  );
};

export default StartConversation;
